<template>
  <div id="app">
    <component :is="layoutComponent">
      <transition name="page-transition" mode="out-in">
        <keep-alive :include="cachedViews">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </transition>
    </component>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';


export default {
  name: 'App',
  components: {
    MainLayout,
  },
  computed: {
    layoutComponent() {
      return 'MainLayout';
    },
    cachedViews() {
      return ['PublicationsView'];
    },
  },
};
</script>

<style>
#app {
  min-height: 100vh;
  background-color: var(--background-color);
}

.plain-layout {
  min-height: 100vh;
}

/* Page Transition Animation */
.page-transition-enter-active,
.page-transition-leave-active {
  transition: opacity 0.2s ease;
}
.page-transition-enter,
.page-transition-leave-to {
  opacity: 0;
}
</style>
